"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UINT128 = exports.UINT64 = exports.ONE_2_DP = exports.ONE_4_DP = exports.ONE_10_DP = exports.ONE_14_DP = exports.ONE_16_DP = exports.HOURS_IN_YEAR = exports.SECONDS_IN_YEAR = void 0;
exports.maximum = maximum;
exports.minimum = minimum;
exports.mulScale = mulScale;
exports.mulScaleRoundUp = mulScaleRoundUp;
exports.divScale = divScale;
exports.divScaleRoundUp = divScaleRoundUp;
exports.expBySquaring = expBySquaring;
exports.compoundEverySecond = compoundEverySecond;
exports.compoundEveryHour = compoundEveryHour;
exports.sqrt = sqrt;
const SECONDS_IN_YEAR = BigInt(365 * 24 * 60 * 60);
exports.SECONDS_IN_YEAR = SECONDS_IN_YEAR;
const HOURS_IN_YEAR = BigInt(365 * 24);
exports.HOURS_IN_YEAR = HOURS_IN_YEAR;
const ONE_2_DP = BigInt(1e2);
exports.ONE_2_DP = ONE_2_DP;
const ONE_4_DP = BigInt(1e4);
exports.ONE_4_DP = ONE_4_DP;
const ONE_10_DP = BigInt(1e10);
exports.ONE_10_DP = ONE_10_DP;
const ONE_14_DP = BigInt(1e14);
exports.ONE_14_DP = ONE_14_DP;
const ONE_16_DP = BigInt(1e16);
exports.ONE_16_DP = ONE_16_DP;
const UINT64 = BigInt(2) << BigInt(63);
exports.UINT64 = UINT64;
const UINT128 = BigInt(2) << BigInt(127);
exports.UINT128 = UINT128;
function maximum(n1, n2) {
    return n1 > n2 ? n1 : n2;
}
function minimum(n1, n2) {
    return n1 < n2 ? n1 : n2;
}
function mulScale(n1, n2, scale) {
    return (n1 * n2) / scale;
}
function mulScaleRoundUp(n1, n2, scale) {
    return mulScale(n1, n2, scale) + BigInt(1);
}
function divScale(n1, n2, scale) {
    return (n1 * scale) / n2;
}
function divScaleRoundUp(n1, n2, scale) {
    return divScale(n1, n2, scale) + BigInt(1);
}
function expBySquaring(x, n, scale) {
    if (n === BigInt(0))
        return scale;
    let y = scale;
    while (n > BigInt(1)) {
        if (n % BigInt(2)) {
            y = mulScale(x, y, scale);
            n = (n - BigInt(1)) / BigInt(2);
        }
        else {
            n = n / BigInt(2);
        }
        x = mulScale(x, x, scale);
    }
    return mulScale(x, y, scale);
}
function compound(rate, scale, period) {
    return expBySquaring(scale + rate / period, period, scale) - scale;
}
function compoundEverySecond(rate, scale) {
    return compound(rate, scale, SECONDS_IN_YEAR);
}
function compoundEveryHour(rate, scale) {
    return compound(rate, scale, HOURS_IN_YEAR);
}
function sqrt(value) {
    if (value < BigInt(0))
        throw Error("square root of negative numbers is not supported");
    if (value < BigInt(2))
        return value;
    function newtonIteration(n, x0) {
        const x1 = (n / x0 + x0) >> BigInt(1);
        if (x0 === x1 || x0 === x1 - BigInt(1))
            return x0;
        return newtonIteration(n, x1);
    }
    return newtonIteration(value, BigInt(1));
}
//# sourceMappingURL=math-lib.js.map